export const ApiCreateSpace = Symbol('ApiCreateSpace');
